import http from '@/services/http';


const SurveyHttp = {
  async getSurveyByType(payload) {
    try {
      const requestBody = { params: payload };

      const { data } = await http.get('/cardfree-api/v1/form', requestBody);

      const activeSurvey = data.find(form => form.isActive);

      if (activeSurvey) {
        return activeSurvey.id;
      }

      throw new Error('Survey form is not configured for this merchant.');
    }
    catch (error) {
      throw error;
    }
  },

  async getSurveyById(surveyId) {
    try {
      const { data } = await http.get(`/cardfree-api/v1/form/${surveyId}`);

      return data;
    }
    catch (error) {
      throw error;
    }
  },

  async postSurvey(surveyId, requestBody) {
    try {
      await http.post(`/cardfree-api/v1/form/${surveyId}`, requestBody);
    }
    catch (error) {
      throw error;
    }
  }
};

export default SurveyHttp;
